// extracted by mini-css-extract-plugin
module.exports = {"Cards":"src-components-Tickets-Kefus-KefuDetails-Accounts-Accounts-module__Cards--3Zmz4","table":"src-components-Tickets-Kefus-KefuDetails-Accounts-Accounts-module__table--5FYEY"};